import {} from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { DateTime } from 'luxon';
import ITimeRange from 'types/TimeRange';
import './ReportPrintHeader.scss';

export interface IReportPrintHeaderProps {
  className?: string | object;
  title: string;
  timeRange: ITimeRange<DateTime>;
  children?: React.ReactNode;
}

const ReportPrintHeader = (props: IReportPrintHeaderProps) => {
  const { className, title, timeRange, children } = props;

  function getTimeRangeFormat() {
    const today = DateTime.local();
    const sameYears = today.hasSame(timeRange.startTime, 'year') && today.hasSame(timeRange.endTime, 'year');
    return sameYears ? 'EEE, MMM d' : 'EEE, MMM d, yyyy';
  }

  const renderTimeRange = () => {
    const formattedStartTime = timeRange.startTime.toFormat(getTimeRangeFormat());
    const formattedEndTime = timeRange.endTime.toFormat(getTimeRangeFormat());

    if (formattedStartTime === formattedEndTime) {
      return formattedStartTime;
    } else {
      return formattedStartTime + ' - ' + formattedEndTime;
    }
  };

  const classes = classNames('report-print-header', 'print', 'my-5', className);

  return (
    <div className={classes}>
      <h2 className="mb-3">{title}</h2>
      <div className="time-range">{renderTimeRange()}</div>
      {children && <div>{children}</div>}
    </div>
  );
};

export default ReportPrintHeader;
